import { createTheme } from 'bold-ui'

const theme = createTheme()

export default theme
